var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6671 15.8333C17.1254 15.8333 17.5004 15.4583 17.5004 15V3.33333C17.5004 2.875 17.1254 2.5 16.6671 2.5H5.00044C4.5421 2.5 4.1671 2.875 4.1671 3.33333C4.1671 3.79167 4.5421 4.16667 5.00044 4.16667H14.6671L2.7421 16.075C2.4171 16.4 2.4171 16.925 2.7421 17.25C3.0671 17.575 3.5921 17.575 3.9171 17.25L15.8338 5.35833V15C15.8338 15.4583 16.2088 15.8333 16.6671 15.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpRight);
export default __webpack_public_path__ + "static/media/icon_arrow_up_right.97bc95ca7eac614230a3947739c4ab68.svg";
export { ForwardRef as ReactComponent };